let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    if( jQuery('body').hasClass('is-drawer') ){
        jQuery('.header .hamburger').trigger('click')
    }
    if(jQuery('body').hasClass('is-search')){
        console.log('ashbdioasdiabsdoiabsohibdais')
        jQuery('body').toggleClass('is-search')
    }



})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    if (jQuery(this).hasClass('is-active')) {
        // jQuery('.drawer').attr('tabindex', '-1')
    } else {
        // jQuery('.drawer').attr('tabindex', '1').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

    jQuery('.header__right').scrollTop(0)

})

jQuery(document).on('keydown', function (e) {

    if( jQuery('body').hasClass('is-search') ){
        if (e.keyCode === 27) {
            jQuery('body').removeClass('is-search');
            setTimeout(function () {
                jQuery('.header__search').focus();
            }, 100); // Adjust the timeout delay as needed
        }
    }

    if( jQuery('body').hasClass('is-drawer') ){
        if (e.keyCode === 27) {
            jQuery('body').removeClass('is-drawer');
            setTimeout(function () {
                jQuery('.header__right__buttons .hamburger').focus();
            }, 100); // Adjust the timeout delay as needed
        }
    }
});

jQuery('.header__search').on('click', function (e) {
    jQuery('body').toggleClass('is-search')
    jQuery('body').removeClass('is-drawer')
    setTimeout(function () {
        jQuery('.search__form #drawer_search_input')[0].focus();
    }, 420);
})

jQuery('.close__search').on('click', function (e) {
    jQuery('body').toggleClass('is-search')
    setTimeout(function () {
        jQuery('.header__search').focus();
    }, 100);
})

document.addEventListener('keyup', function(e) {
    var logobutton = jQuery('#drawer .header__logo a');
    var drawerbutton = jQuery('#drawer #hamburger-toggle button');
    var lastAnchorElement = jQuery('#drawer #menu-footer-menu li:last-child a');
    var firstAnchorElement = jQuery('#drawer #menu-footer-menu li:first-child a');
    var next_to_logo = jQuery( '#drawer .drawer__header__right' );

    // console.log(e.keyCode);/

    var headerDrawerButton = jQuery( '#header .hamburger-toggle button' );

    if (e.keyCode == 13 && jQuery('body').hasClass('is-drawer') ) {

        e.preventDefault();

        logobutton.attr('tabindex', '0').focus();

        lastAnchorElement.on('keydown', function(e) {

            e.preventDefault();

            if (e.key === 'Tab') {
                if (  e.shiftKey) {

                    firstAnchorElement.attr('tabindex', '0').focus();
                    e.preventDefault();

                } else {

                    logobutton.attr('tabindex', '0').focus();
                    e.preventDefault();

                }
            }
        });

        logobutton.on('keydown', function(e) {

            e.preventDefault();

            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    lastAnchorElement.attr('tabindex', '0').focus();


                    e.preventDefault();

                } else {
                    console.log(',asdbaisbdoasbdouabsdouabsoudb')
                    next_to_logo.attr('tabindex', '0').focus();
                    e.preventDefault();
                }
            }
        });

    }else if( !jQuery('body').hasClass('is-drawer') ){
        lastAnchorElement.off()
    }

    if(e.keyCode == 27 && jQuery('body').hasClass('is-drawer')){
        lastAnchorElement.off()
        headerDrawerButton.attr('tabindex', '0').focus()

        jQuery('body').toggleClass('is-drawer')
        jQuery('.hamburger').toggleClass('is-active')
    }
});


jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        parentEl.toggleClass('open').next().slideToggle()
    }

})

var lastScrollTop = 0

function checkScroll() {
    let scrollTop = jQuery(window).scrollTop();

    if (scrollTop > 40) {
        jQuery('.first-nav__holder').css({'visibility': 'hidden'});
        jQuery('.header').addClass('header--white');
    } else {
        jQuery('.first-nav__holder').css({'visibility': 'visible'});
        jQuery('.header').removeClass('header--white');
    }

    if (lastScrollTop > scrollTop) {
        jQuery('.first-nav__holder').css({'visibility': 'visible'});
        jQuery('.first-nav__holder').addClass('first-nav__holder--white');
    }

    if (scrollTop > lastScrollTop || scrollTop <= 40) {
        jQuery('.first-nav__holder').removeClass('first-nav__holder--white');
    }

    lastScrollTop = scrollTop;
}

// function adjustHeaderTop() {
//     const announcementBarHeight = document.querySelector('.header__announcement').offsetHeight;
//     document.querySelector('.sticky-header').style.top = `${announcementBarHeight}px`;
// }

jQuery(document).ready(function(e) {

    if(jQuery('.sticky-navigation').length > 0){

        var lastScrollTop = 0;

        var headerHeight = jQuery('.header').outerHeight();
        var stickyNav = jQuery('.sticky-navigation');
        var stickyNavHeight = jQuery('.sticky-navigation').outerHeight();
        var stickyNavOffset = jQuery('.sticky-navigation').offset().top;

        var bodyHeight = jQuery('body').height();

        stickyNav.css( "top", headerHeight );

        jQuery(window).scroll(function() {

            var headerHeight = jQuery('.header').outerHeight();
            var stickyNav = jQuery('.sticky-navigation');
            var stickyNavHeight = jQuery('.sticky-navigation').outerHeight();

            var scrollTop = jQuery(this).scrollTop() - 2*stickyNavHeight;

            if(scrollTop  < lastScrollTop) {
                ///this is up
               if(lastScrollTop  -  scrollTop + stickyNavHeight > 1){
                   stickyNav.addClass('show');
               }

            } else {
               ///this is down
               if(scrollTop > headerHeight +  stickyNavHeight + stickyNavHeight){
                   stickyNav.removeClass('show');
               }
            }

            lastScrollTop = scrollTop;
        })
    }

    if(jQuery('.sticky-header').length > 0){

        var lastScrollTop = 0;

        // var headerHeight = jQuery('.header').outerHeight();
        var stickyNav = jQuery('.sticky-header');
        var stickyNavHeight = jQuery('.sticky-header').outerHeight();
        var stickyNavOffset = jQuery('.sticky-header').offset().top;

        var bodyHeight = jQuery('body').height();

        // stickyNav.css( "top", headerHeight );

        jQuery(window).scroll(function() {

            // var headerHeight = jQuery('.header').outerHeight();
            var stickyNav = jQuery('.sticky-header');
            var stickyNavHeight = jQuery('.sticky-header').outerHeight();

            var scrollTop = jQuery(this).scrollTop() - 2*stickyNavHeight;

            if(scrollTop  < lastScrollTop) {
                ///this is up
               if(lastScrollTop  -  scrollTop + stickyNavHeight > 1){
                   stickyNav.addClass('show');
               }

            } else {
               ///this is down
               if(scrollTop > stickyNavHeight + stickyNavHeight){
                   stickyNav.removeClass('show');
               }
            }

            lastScrollTop = scrollTop;
        })
    }

    checkScroll();
    

    jQuery(window).on('scroll', function() {
        checkScroll();
    });
    // window.addEventListener('resize', adjustHeaderTop);
    // adjustHeaderTop();
})


///only footer tinklas add target blank
jQuery(document).ready(function(e){
    jQuery('.footer__social a').attr('target', '_blank');
});
